// extracted by mini-css-extract-plugin
export default {"carOffers":"AddOfferOnCar_carOffers__l19ju","carOfferButton":"AddOfferOnCar_carOfferButton__SpJ1k","carOfferButtonAlt":"AddOfferOnCar_carOfferButtonAlt__CxCjh"};